import { render, staticRenderFns } from "./help-list.vue?vue&type=template&id=3acd1642&scoped=true"
import script from "./help-list.vue?vue&type=script&lang=js"
export * from "./help-list.vue?vue&type=script&lang=js"
import style0 from "./help-list.vue?vue&type=style&index=0&id=3acd1642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd1642",
  null
  
)

export default component.exports